<template>
  <div id="contenedor-tiposobra-default">
    <v-container
      fluid>
      <v-card
        class="mb-4"
        flat>
        <v-card-text>
          <titulo-tool-bar></titulo-tool-bar>
          <tool-bar
            class="mb-4"
            :filtros="filtros"
            v-on:nuevoTipoObra="registrarNuevoTipoObra"
            >
          </tool-bar>
        </v-card-text>
      </v-card>
      <v-card
        flat>
        <v-card-text>
          <listado :listadoTiposObras="getTiposObras"></listado>
        </v-card-text>
      </v-card>
    </v-container>
    <!-- CUADRO DE DIALOGO AGREGAR -->
    <v-dialog
      v-model="mostrarVentanaRegistrarNuevoTipoObra"
      :width="!$vuetify.breakpoint.mobile ? '500' : '90%'">
      <registrar-nuevo-tipo-obra
        v-if="mostrarVentanaRegistrarNuevoTipoObra"
        v-on:cerrar="cerrarRegistrarNuevoTipoObra">
      </registrar-nuevo-tipo-obra>
    </v-dialog>
    <!-- CUADRO DE DIALOGO EDITAR -->
    <v-dialog
    v-if="esteTipoObra"
      v-model="mostrarVentanaEditarTipoObra"
      :width="!$vuetify.breakpoint.mobile ? '500' : '90%'">
      <editar-tipo-obra
      :tipoObraEditar="esteTipoObra"
        v-on:cerrar="cerrarEditarTipoObra">
      </editar-tipo-obra>
    </v-dialog>
    <!-- CUADRO DE DIALOGO ELIMINAR -->
    <v-dialog
    v-if="esteTipoObra"
      v-model="mostrarVentanaEliminarTipoObra"
      :width="!$vuetify.breakpoint.mobile ? '450' : '90%'">
      <eliminar-tipo-obra
      :tipoObraEliminar="esteTipoObra"
        v-on:cerrar="cerrarEliminarTipoObra">
      </eliminar-tipo-obra>
    </v-dialog>
  </div>
</template>

<script>
import TIPOS_OBRAS from '@/graphql/querys/administracion/catalogos/tiposobras/tiposObras.gql';
import TituloToolBar from './TituloToolBar.vue';
import RegistrarNuevoTipoObra from '@/components/administracion/configuracion/catalogos/tiposobra/Nuevo.vue';
import EditarTipoObra from '@/components/administracion/configuracion/catalogos/tiposobra/Editar.vue';
import EliminarTipoObra from '@/components/administracion/configuracion/catalogos/tiposobra/Eliminar.vue';
import ToolBar from './ToolBar.vue';
import Listado from './listado/Main.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'TiposObraDefault',
  components: {
    TituloToolBar,
    RegistrarNuevoTipoObra,
    EditarTipoObra,
    EliminarTipoObra,
    ToolBar,
    Listado,
  },
  data() {
    return {
      mostrarVentanaRegistrarNuevoTipoObra: false,
      mostrarVentanaEditarTipoObra: false,
      mostrarVentanaEliminarTipoObra: false,
      esteTipoObra: null,
      filtros: {
        buscarTexto: '',
      },
    };
  },
  apollo: {
    tiposObras: {
      query: TIPOS_OBRAS,
    },
  },
  mounted() {
    eventBus.$on('editar-tipo-obra', (tipoObra) => {
      this.esteTipoObra = tipoObra;
      this.mostrarVentanaEditarTipoObra = true;
    });
    eventBus.$on('eliminar-tipo-obra', (tipoObra) => {
      this.esteTipoObra = tipoObra;
      this.mostrarVentanaEliminarTipoObra = true;
    });
  },
  methods: {
    registrarNuevoTipoObra() {
      this.mostrarVentanaRegistrarNuevoTipoObra = true;
    },
    cerrarRegistrarNuevoTipoObra() {
      this.mostrarVentanaRegistrarNuevoTipoObra = false;
    },
    cerrarEditarTipoObra() {
      this.mostrarVentanaEditarTipoObra = false;
      this.esteTipoObra = null;
    },
    cerrarEliminarTipoObra() {
      this.mostrarVentanaEliminarTipoObra = false;
      this.esteTipoObra = null;
    },
  },
  computed: {
    getTiposObras() {
      if (!this.tiposObras) return [];
      return this.tiposObras
      // Filtrar por Texto de Busqueda
        .filter((tipoObra) => {
          if (!this.filtros.buscarTexto) return tipoObra;
          const expt = new RegExp(this.filtros.buscarTexto, 'gi');
          const descripcion = this.$normalizacionTexto(tipoObra.descripcion);
          return (
            expt.test(descripcion)
            || expt.test(tipoObra.descripcion)
          );
        });
    },
  },
};
</script>

<style lang="scss">

</style>
